import { h, Component } from 'preact'
import Table from '../table/Table'
import { Modal, ModalHeader, ModalBody, ModalFooter } from '../modal'
import ButtonControl from '../button-control'

interface CustomerClient {
  id: string,
  name: string,
  clientId: string,
  createdAt: string
}

interface Props {
  onRevokeButtonClick: Function,
  clients: Array<CustomerClient>
}

interface State {
  clientToDelete: CustomerClient|null
}

class List extends Component<Props, State> {
  constructor (props: Props) {
    super(props)

    this.state = { clientToDelete: null }
  }

  render ({ clients, onRevokeButtonClick }: Props, { clientToDelete }: State) {
    const model = [{
      header: 'Label',
      accessor: 'label'
    }, {
      header: 'Client ID',
      accessor: 'client_id'
    }, {
      header: 'Created at',
      accessor: 'created_at'
    }, {
      header: 'Action',
      accessor: 'action'
    }]
    let self = this
    const rows = clients.map(client => (
      {
        label: client.name,
        client_id: client.clientId,
        created_at: client.createdAt,
        action: <ButtonControl class='qa-delete-client' newStyle title='Delete' variant='warning'
          onClick={() => self.setState({ clientToDelete: client })} />
      }
    ))
    return <div class='oauth2-clients-list'>
      <h4>Generated OAuth2 Clients</h4>
      <Table model={model} rows={rows} narrow />
      <Modal isOpen={clientToDelete != null}>
        <ModalHeader title='Delete this client?' onClose={() => this.setState({ clientToDelete: null })} />
        <ModalBody>If you delete this client, it's gone for good</ModalBody>
        <ModalFooter>
          <ButtonControl newStyle title='Delete' variant='warning' class='qa-confirm-delete-client'
            onClick={() => this.setState({ clientToDelete: null }, onRevokeButtonClick(clientToDelete))} />
          <ButtonControl newStyle title='Cancel' class='qa-cancel-delete-client'
            onClick={() => this.setState({ clientToDelete: null })} />
        </ModalFooter>
      </Modal>
    </div>
  }
}

export default List
